module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[96]217.bd1dd23.woff2";